<template>
    <div class="hello-page-wrapper video-player-wrapper bodyfont-unauth">
        <spinner class="pink" v-model="toggleSpinner" v-if="toggleSpinner" size="lg" fixed text="refreshing event"></spinner>
        <div class="col-md-12 pinkbordercomp" v-if="mainLiveEvent && showRulesComp && showJoin(mainLiveEvent)">
            <rulescomp v-if="showRulesComp" :data="mainLiveEvent" v-bind:style="{border: '1px solid ' + getCorpHeaderColor}">Loading event rules</rulescomp>
        </div>
            <div class="container-fluid" v-if="mainLiveEvent && currentVideo">
                <br>
                    <div class="video-player autoheight">
                        <div class="left-video-icons"></div>
                        <div v-if="currentVideo" class="reset-video-width">
                            <h2 class="text-left">{{mainLiveEvent.title}}</h2>
                        <jwplayer id="mainVideoPlayer" :data="currentVideo">Loading the player...</jwplayer>
                        </div>
                        <div class="clearfix"></div>
                    </div>
            </div>

        <!--<div v-if="!videoCompleted" class="container">-->
        <div class="container">
            <div class="row" >
                <div class="col-md-12">
                    <div class="player-content">
                        <p class="video-description" v-if="mainLiveEvent">
                            {{mainLiveEvent.longDescription}}
                        </p>
                        <div style="float: left" v-if="mainLiveEvent && !showJoin(mainLiveEvent)">
                        <div v-on:click="calendarLogging($event, mainLiveEvent.title)" title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-bind:style="{ color: getCorpButtonColor + ' !important', border: '1px solid ' + getCorpButtonColor}">
                            Add to Calendar
                            <span class="start">{{mainLiveEvent.start_date}}</span>
                            <span class="end">{{mainLiveEvent.end_date}}</span>
                            <span class="timezone">America/New_York</span>
                            <span class="title">{{mainLiveEvent.title}}</span>
                            <span class="description">{{mainLiveEvent.longDescription}}</span>
                            <span class="location">{{eventURL}}/event/{{mainLiveEvent.eventId}}</span>
                        </div>
                            <!--<button class="button btn btn-pink btn-primary pull-left" type="button" v-if="showJoin(mainLiveEvent)" @click="joinEvent(mainLiveEvent)"><i class="fa 2x fa-arrow-circle-right" aria-hidden="true"></i>&nbsp;Go to Event&nbsp;</button>-->
                    </div>
                        <div class="container-icons vpage" v-if="getCorpButtonColor === '#f0617d'">
                            <social-sharing  v-bind:url = "videoURL" v-bind:media= "videoURL" v-bind:quote = "'TONE Networks | Expert Advice on Demand'" v-bind:description = "currentVideo.Description" v-bind:title = "currentVideo.title" inline-template>
                                <div>
                                    <network network="facebook">
                                        <i class="fa fa-2x fa-facebook cursor"></i>
                                    </network>
                                    <network network="twitter">
                                        <i class="fa fa-2x fa-twitter cursor"></i>
                                    </network>
                                    <network network="linkedin" class="holder">
                                        <i class="fa fa-2x fa-linkedin cursor"></i>
                                    </network>
                                    <network network="email" class="holder">
                                        <i class="fa fa-2x fa-envelope cursor"></i>
                                    </network>
                                </div>
                            </social-sharing>
                        </div>
                        <div class="container-icons vpage" v-if="getCorpButtonColor !== '#f0617d'">
                            <social-sharing  v-bind:url = "videoURL" v-bind:media= "videoURL" v-bind:quote = "'TONE Networks | Expert Advice on Demand'" v-bind:description = "currentVideo.Description" v-bind:title = "currentVideo.title" inline-template>
                                <div>
                                    <network network="facebook" v-bind:style="{backgroundColor: '#A9A9A9 !important'}">
                                        <i class="fa fa-2x fa-facebook cursor" v-bind:style="{color: '#FFFFFF !important'}"></i>
                                    </network>
                                    <network network="twitter" v-bind:style="{backgroundColor: '#A9A9A9 !important'}">
                                        <i class="fa fa-2x fa-twitter cursor" v-bind:style="{color: '#FFFFFF !important'}"></i>
                                    </network>
                                    <network network="linkedin" class="holder" v-bind:style="{backgroundColor: '#A9A9A9 !important'}">
                                        <i class="fa fa-2x fa-linkedin cursor" v-bind:style="{color: '#FFFFFF !important'}"></i>
                                    </network>
                                    <network network="email" class="holder" v-bind:style="{backgroundColor: '#A9A9A9 !important'}">
                                        <i class="fa fa-2x fa-envelope cursor" v-bind:style="{color: '#FFFFFF !important'}"></i>
                                    </network>
                                </div>
                            </social-sharing>
                        </div>
<!--                        <div class="profile-content" v-if="videoExpert">-->
<!--                            <a :href="'/expert/' + videoExpert[0].expertId + '/' + videoExpert[0].name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" target="_blank" rel="opener">-->
<!--                            <img v-bind:src="videoExpert[0].small_image" :title="videoExpert && videoExpert[0].name" :alt="videoExpert && videoExpert[0].name">-->
<!--                            <h4>{{videoExpert && videoExpert[0].name}}</h4>-->
<!--                            <span>{{videoExpert && videoExpert[0].experties}}</span>-->
<!--                            </a>-->
<!--                        </div>-->
<!--                        <p class="video-text">-->
<!--                            {{videoExpert && videoExpert[0].areasofexpertise}}-->
<!--                        </p>-->
                        <!--<div class="row">-->
                            <!--<div class="col-xs-4 col-sm-4 col-md-4 col-lg-3">-->
                                <!--<button class="btn btn-danger recently-watched-btn btn-transparent btn-lg"-->
                                        <!--@click="toggleViewTranscript">-->
                                    <!--<span v-show="!viewTranscript">View Transcript</span>-->
                                    <!--<span v-show="viewTranscript">Hide Transcript</span>-->
                                <!--</button>-->
                            <!--</div>-->
                            <!--<div class="col-xs-12 col-sm-8 col-md-8 col-lg-9">-->
                                <!--<div class="side-content" v-if="getCurrentVideoTranscript">-->
                                    <!--<div v-show="viewTranscript" class="boxes"-->
                                         <!--:class="{'animated fadeIn': viewTranscript, 'animated fadeOut': !viewTranscript}"-->
                                         <!--&gt;-->
                                        <!--<pre><p v-html="getCurrentVideoTranscript.vtt_file">-->
                                        <!--</p></pre>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<div class="profile-content" v-if="getExpert">-->
                            <!--<img v-bind:src="getExpert[0].small_image" alt="">-->
                            <!--<h4>{{getExpert[0].name}}</h4>-->
                            <!--<span>{{getExpert[0].experties}}</span>-->
                        <!--</div>-->
                        <!--<p class="video-text">-->
                            <!--{{getExpert[0].biography}}-->
                        <!--</p>-->
                    </div>
                </div>
                <div class="col-md-12 pinkbordercomp" v-if="mainLiveEvent && showRulesComp && !showJoin(mainLiveEvent)">
                    <rulescomp v-if="showRulesComp" :data="mainLiveEvent" v-bind:style="{borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}">Loading event rules</rulescomp>
                </div>
                <div class="gap clearfix"></div>
                <div class="text-center">
                    <button v-if="!getCorporateGiftingCode"  @click="$router.push('/signup')" type="button" class="btn btn-success btn-lg">Start Your Free Trial</button>
                    <button  v-if="getCorporateGiftingCode && getCorporateClient" @click="redeemCode()" type="button" class="btn btn-success btn-lg">{{getCorporateGiftInfo.button_label_01}}</button>
                </div>
                <div class="gap clearfix"></div>
                <h2 v-if="toneLiveHeading" v-html="toneLiveHeading"></h2>
               <div class="container">
                <div class="row morevediosrow" v-if="allLiveEvents">
                    <div class="col-sm-6" v-if="allLiveEvents[0]">
                        <a :href="'/newevents/' + allLiveEvents[0].eventId" target="_blank" rel="opener">
                        <img :src="allLiveEvents[0].img_url" class="jw-img" :alt="allLiveEvents[0].title" :title="allLiveEvents[0].title"/>
                        <p class="text-wrap-title cursor">{{allLiveEvents[0].title}}</p>
                    </a>
                        <div style="float: left; margin-bottom: 5px;" v-if="allLiveEvents[0]">
                            <!--<button class="button btn btn-pink btn-primary pull-left" type="button" v-if="showJoin(allLiveEvents[0])" @click="joinEvent(allLiveEvents[0])"><i class="fa 2x fa-arrow-circle-right" aria-hidden="true"></i>&nbsp;Go to Event&nbsp;</button>-->
                            <div v-on:click="calendarLogging($event, allLiveEvents[0].title)" title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-bind:style="{ color: getCorpButtonColor + ' !important', border: '1px solid ' + getCorpButtonColor}">
                                Add to Calendar
                                <span class="start">{{allLiveEvents[0].start_date}}</span>
                                <span class="end">{{allLiveEvents[0].end_date}}</span>
                                <span class="timezone">America/New_York</span>
                                <span class="title">{{allLiveEvents[0].title}}</span>
                                <span class="description">{{allLiveEvents[0].longDescription}}</span>
                                <span class="location">{{eventURL}}/event/{{allLiveEvents[0].eventId}}</span>
                            </div>
                        </div>
                    </div>
                   <div class="col-sm-6" v-if="allLiveEvents[1]" @click="">
                   <a :href="'/newevents/' + allLiveEvents[1].eventId" target="_blank" rel="opener">
                        <img :src="allLiveEvents[1].img_url" class="jw-img" :alt="allLiveEvents[1].title" :title="allLiveEvents[1].title"/>
                        <p class="text-wrap-title cursor" @click="">{{allLiveEvents[1].title}}</p>
                   </a>
                       <div style="float: left; margin-bottom: 5px;" v-if="allLiveEvents[1]">
                           <!--<button class="button btn btn-pink btn-primary pull-left" type="button" v-if="showJoin(allLiveEvents[1])" @click="joinEvent(allLiveEvents[1])"><i class="fa 2x fa-arrow-circle-right" aria-hidden="true"></i>&nbsp;Go to Event&nbsp;</button>-->
                           <div v-on:click="calendarLogging($event, allLiveEvents[1].title)" title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-bind:style="{ color: getCorpButtonColor + ' !important', border: '1px solid ' + getCorpButtonColor}">
                               Add to Calendar
                               <span class="start">{{allLiveEvents[1].start_date}}</span>
                               <span class="end">{{allLiveEvents[1].end_date}}</span>
                               <span class="timezone">America/New_York</span>
                               <span class="title">{{allLiveEvents[1].title}}</span>
                               <span class="description">{{allLiveEvents[1].longDescription}}</span>
                               <span class="location">{{eventURL}}/event/{{allLiveEvents[1].eventId}}</span>
                           </div>
                       </div>
               </div>
                </div>
            </div>
                <div class="gap clearfix"></div>
                <div class="sliderTalkBox">
                    <h2 v-if="toneTalkHeading" v-html="toneTalkHeading"></h2>
                    <p v-if="toneTalkDesc" v-html="toneTalkDesc">
                        <!--Join us in our moderated discussions and tap into the wisdom of women helping women.  At TONE, we believe all women have something to share.-->
                    </p>
                    <div class="slider responsive-slick-slider" v-if="allTalkEvents">
                        <div class="col-sm-4" v-for="talkEvent in allTalkEvents" >
                            <a :href="'/event/' + talkEvent.eventId" target="_blank" rel="opener">
                            <h2 style="color:#5E5E5E;">{{getDateReference(talkEvent.start_date, 'live')}}:&nbsp;{{talkEvent.title}}</h2>
                            </a>
                            <p>
                                {{talkEvent.longDescription}}
                            </p>
                            <h5>{{getDateReference(talkEvent.start_date, 'live2')}}</h5>
                            <div v-on:click="calendarLogging($event, talkEvent.title)" title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-bind:style="{ color: getCorpButtonColor + ' !important', border: '1px solid ' + getCorpButtonColor}">
                                Add to Calendar
                                <span class="start">{{talkEvent.start_date}}</span>
                                <span class="end">{{talkEvent.end_date}}</span>
                                <span class="timezone">America/New_York</span>
                                <span class="title">{{talkEvent.title}}</span>
                                <span class="description">{{talkEvent.longDescription}}</span>
                                <span class="location">{{eventURL}}/event/{{talkEvent.eventId}}</span>
                            </div>
                            <!--<button class="button btn btn-pink btn-primary pull-left" type="button" v-if="showJoin(talkEvent)" @click="joinEvent(talkEvent)"><i class="fa 2x fa-arrow-circle-right" aria-hidden="true"></i>&nbsp;Go to Event&nbsp;</button>-->
                            <!--time left in event {{timeLeftInEvent(evn.start_date)}}-->
                            <!--<span>72 Members | 302 Comments</span>-->
                            <!--<button class="button btn btn-pink btn-primary pull-left"  @click="triggerLogin" type="button">Reserve your spot</button>-->
                            <!--<button  class="btn btn-danger expert-section-btn btn-transparent">Reserve a Seat at the Table</button>-->
                            <!--<button type="button" class="btn disabled">Coming Soon</button>-->
                        </div>
                    </div>
                </div>
                <!--<div title="Add to Calendar" class="addeventatc">-->
                    <!--Add to Calendar-->
                    <!--<span class="start">11-06-2018 08:00</span>-->
                    <!--<span class="end">11-06-2018 10:00</span>-->
                    <!--<span class="timezone">America/New_York</span>-->
                    <!--<span class="tit1le">Summary of the event</span>-->
                    <!--<span class="description">Description of the event</span>-->
                    <!--<span class="location">Location of the event</span>-->
                <!--</div>-->
                <div class="text-center">
                    <button v-if="!getCorporateGiftingCode"  @click="$router.push('/signup')" type="button" class="btn btn-success btn-lg">Start Your Free Trial</button>
                    <button  v-if="getCorporateGiftingCode && getCorporateClient" @click="redeemCode()" type="button" class="btn btn-success btn-lg">{{getCorporateGiftInfo.button_label_01}}</button>
                </div>
            </div>
        </div>
        <!--<div class="recently-watched">-->
            <!--<div class="container">-->
                <!--<div class="row" v-if="getAuthRecommendedVideos">-->
                    <!--<div class="col-md-12">-->
                        <!--<h2>RELATED VIDEOS</h2>-->
                    <!--</div>-->
                    <!--<div class="col-md-12">-->
                        <!--<div class="content">-->
                            <!--<div class="slider responsive-slick-slider">-->
                                <!--<div v-for = "reccentVideo in recommendationList">-->
                                    <!--<div class="slide-player">-->
                                        <!--<img class="jw-img" :src="reccentVideo.image" @click="setVideoPlayerObject(reccentVideo.mediaid)" />-->
                                        <!--<p class="text-wrap-title">-->
                                            <!--<i class="fa fa-play-circle-o"></i> {{reccentVideo.title}}-->
                                        <!--</p>-->
                                        <!--&lt;!&ndash;<hr>&ndash;&gt;-->
                                        <!--&lt;!&ndash;<p class="right-heart-icon">&ndash;&gt;-->
                                            <!--&lt;!&ndash;<i class="fa fa-2x fa-heart-o"&ndash;&gt;-->
                                               <!--&lt;!&ndash;v-bind:class="{'activeIcons': getVideoStatus(reccentVideo)}" aria-hidden="true" @click=""></i>&ndash;&gt;-->
                                        <!--&lt;!&ndash;</p>&ndash;&gt;-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                    <!--<div class="col-md-12">-->
                        <!--<button @click="redirectToRelatedVideos()" class="btn btn-danger recently-watched-btn btn-transparent btn-lg">View All Your Videos</button>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->
    </div>
</template>

<script>
    import rulescomp from './RulesComp.vue'
    import jwplayer from './JwPlayer.vue'
    import JwPlayList from './JwPlayList.vue'
    import slick from 'slick-carousel'
    import $ from 'jquery'
    import { mapGetters } from 'vuex'
    import store from '../store'
    import { dateHelpers } from '../helpers/dateHelpers.js'
//    import $ from 'jquery'

    export default {
        name: 'player',
        components: {
            jwplayer,
            'jwplaylist': JwPlayList,
            rulescomp
        },
        metaInfo () {
            let self = this
            return {
                title: self.metaTag_pageTitle,
                meta: [
                    {name: 'keywords', content: self.metaTag_keywords},
                    {name: 'description', content: self.metaTag_description},
                    {property: 'og:image', content: self.metaTag_fb_image},
                    {property: 'og:title', content: self.metaTag_fb_title},
                    {property: 'og:site_name', content: self.metaTag_fb_sitename},
                    {
                        property: 'og:description',
                        content: self.metaTag_fb_description
                    },
                    {property: 'twitter:title', content: self.metaTag_tw_title},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: self.metaTag_tw_image},
                    {
                        property: 'twitter:description',
                        content: self.metaTag_tw_description
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                toggleSpinner: false,
                showRulesComp: true,
                activeTab: 0,
                currentVideo: '',
                currentStatus: '',
                currentVideoCode: '',
                recommendationList: '',
                videoCompleted: false,
                videoSqueeze: false,
                hideLeftVideoIcons: false,
                addRightHoverWidthClass: false,
                addIconHoverWidthClass: false,
                showRateHoverBox: false,
                showShareHoverBox: false,
                showEnjoyHoverBox: false,
                addRightHoverEnjoyClass: false,
                addEnjoyHoverClass: false,
                captionTrack: '',
                viewTranscript: false,
                ratingOne: false,
                ratingTwo: false,
                ratingThree: false,
                ratingFour: false,
                hideAll: false,
                videoMessage: '',
                videoMessageIndex: Math.floor(Math.random() * 7),
                videoGif: '',
                videoGifIndex: Math.floor(Math.random() * 4),
                videoURL: window.location.href,
                videoNotFoundFlag: false,
                videoTag: '',
                videoList: '',
                categoryVideoList: '',
                videoExpert: '',
                mainLiveEvent: null,
                allLiveEvents: null,
                allTalkEvents: null,
                eventURL: 'https://www.tonenetworks.com',
                sharingImage: '',
                sharingTitle: '',
                sharingDescription: '',
                toneLiveHeading: 'COMING UP AT TONE',
                toneTalkHeading: 'TONE TALKS',
                toneTalkDesc: 'Join us for our twice monthly livestream coaching events to learn from our experts, executive coaches and one another.',
                metaTag_description: '',
                metaTag_keywords: '',
                metaTag_fb_sitename: '',
                metaTag_pageTitle: '',
                metaTag_fb_image: '',
                metaTag_fb_title: '',
                metaTag_fb_description: '',
                metaTag_tw_image: '',
                metaTag_tw_title: '',
                metaTag_tw_description: ''
            }
        },
        methods: {
            calendarLogging (event, title) {
                // console.log('event was fired', event)
                // console.log('event title', title)
                let self = this
                let userPayload = []
                let uId = 0
                if (self.user) {
                    uId = self.user.userId
                }
                userPayload.push(uId)
                userPayload.push(self.$route.fullPath)
                userPayload.push('ADD_TO_CALENDAR')
                userPayload.push(title)
                self.$store.dispatch('LOG_USER_WITHIN_PAGE_CLICK', userPayload)
            },
            setDynamicSection (coll, key) {
                let valCol = coll.filter(x => {
                    return x.content_id === key
                })
                if (valCol && valCol.length > 0) {
                    return valCol[0].content_value
                } else {
                    return ''
                }
            },
            redeemCode () {
                let self = this
                if (self.getCorporateClient.invitationCode === '2') {
                    self.$router.push(`/corporation/referral/buy/${self.getCorporateClientId}/${self.getCorporateGiftingCode}`)
                } else {
                    self.$router.push(`/corporationgifting/${self.getCorporateClientId}/${self.getCorporateGiftingCode}`)
                }
            },
            createCarousal () {
                $.slick = slick
                const $slick = $(this.$el).find('.responsive-slick-slider')
                $slick.slick({
                    dots: false,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: false
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                })
            },
            getHoursFormatted (time) {
                let hours = time.getHours()
                let minutes = time.getMinutes()
                let ampm = hours >= 12 ? 'pm' : 'am'
                hours = hours % 12
                hours = hours === 0 ? '12' : hours
                minutes = minutes < 10 ? '0' + minutes : minutes
                let strTime = hours + ':' + minutes + ' ' + ampm
                return strTime
            },
            getPacificTime (time) {
                let hours = time.getHours() - 3
                let minutes = time.getMinutes()
                let ampm = hours >= 12 ? 'p.m.' : 'a.m.'
                hours = hours % 12
                hours = hours === 0 ? '12' : hours
                minutes = minutes < 10 ? '0' + minutes : minutes
                let strTime = minutes > 0 ? hours + ':' + minutes + ' ' + ampm : hours + ' ' + ampm
                return strTime
            },
            getDateReference (dte, type) {
                let dt = new Date(dte)
                let dayStr, monStr
                let eDay = dt.getDate()
                let eHours = this.getHoursFormatted(dt)
                let pHours = this.getPacificTime(dt)
                let eMonth = dt.getMonth() + 1
                let day
                // Set Day of Date
                if (dt.getDay() === 0) {
                    day = 'Sunday'
                } else if (dt.getDay() === 1) {
                    day = 'Monday'
                } else if (dt.getDay() === 2) {
                    day = 'Tuesday'
                } else if (dt.getDay() === 3) {
                    day = 'Wednesday'
                } else if (dt.getDay() === 4) {
                    day = 'Thursday'
                } else if (dt.getDay() === 5) {
                    day = 'Friday'
                } else if (dt.getDay() === 6) {
                    day = 'Saturday'
                } else {
                    day = ''
                }
                // Set Date Pattern
                if (eDay === 1) {
                    dayStr = '1st'
                } else if (eDay === 2) {
                    dayStr = '2nd'
                } else if (eDay === 3) {
                    dayStr = '3rd'
                } else if (eDay === 21) {
                    dayStr = '21st'
                } else if (eDay === 22) {
                    dayStr = '22nd'
                } else if (eDay === 23) {
                    dayStr = '23rd'
                } else if (eDay === 31) {
                    dayStr = '31st'
                } else {
                    dayStr = eDay + 'th'
                }
                // Set Month
                if (eMonth === 1) {
                    monStr = 'January'
                } else if (eMonth === 2) {
                    monStr = 'February'
                } else if (eMonth === 3) {
                    monStr = 'March'
                } else if (eMonth === 4) {
                    monStr = 'April'
                } else if (eMonth === 5) {
                    monStr = 'May'
                } else if (eMonth === 6) {
                    monStr = 'June'
                } else if (eMonth === 7) {
                    monStr = 'July'
                } else if (eMonth === 8) {
                    monStr = 'August'
                } else if (eMonth === 9) {
                    monStr = 'September'
                } else if (eMonth === 10) {
                    monStr = 'October'
                } else if (eMonth === 11) {
                    monStr = 'November'
                } else if (eMonth === 12) {
                    monStr = 'December'
                }
                if (type === 'btn') {
                    return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!'
                } else if (type === 'live') {
                    return monStr + ' ' + eDay
                } else if (type === 'live2') {
                    return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET' + ' / ' + pHours + ' PT'
                } else if (type === 'str') {
                    return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET' + ' / ' + pHours + ' PT'
                } else {
                    return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET' + ' / ' + pHours + ' PT'
                }
            },
            setVideoPlayerObject (eventId) {
                this.$router.push(`/newevents/${eventId}`)
                location.reload()
            },
            redirectToHome () {
                this.$router.push('/')
            },
            getMinutesBetweenDates (startDate, endDate) {
                var diff = endDate.getTime() - startDate.getTime()
                return (diff / 60000)
            },
            isEventToday (evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
                let eventDate = new Date(evtDate)
                let eventEndDate = new Date(endDate)
                let currentDate = this.returnEasternTime()
                let switchTime = parseInt(defaultSwitchTime)
                if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                    switchTime = parseInt(eventSwtichTime)
                }
                if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                    if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            returnEasternTime () {
                let offset = -5
                if (dateHelpers.dstEnabled(new Date())) {
                    offset = -4.0
                }
                let clientDate = new Date()
                let utc = clientDate.getTime() + (clientDate.getTimezoneOffset() * 60000)
                let serverDate = new Date(utc + (3600000 * offset))
                return serverDate
            },
            timeLeftInEvent (evtDate) {
                let eventDate = new Date(evtDate)
                let currentDate = this.returnEasternTime()
                return this.getMinutesBetweenDates(currentDate, eventDate)
            },
            showJoin (bEvent) {
                if (this.isEventToday(bEvent.start_date, bEvent.end_date, bEvent.eventSwitchTime, this.getEventSwitchTime)) {
                    return true
                }
                return false
            },
            joinEvent (event) {
                if (sessionStorage.getItem('redirectPath')) {
                    sessionStorage.removeItem('redirectPath')
                    sessionStorage.setItem('redirectPath', `/event/${event.eventId}`)
                } else {
                    sessionStorage.setItem('redirectPath', `/event/${event.eventId}`)
                }
                store.commit('setTriggerLogin', {loginStatus: true})
                // this.$router.push(`/rules/` + event.eventId)
            },
            triggerLogin () {
                if (sessionStorage.getItem('redirectPath')) {
                    sessionStorage.removeItem('redirectPath')
                    sessionStorage.setItem('redirectPath', `/events`)
                } else {
                    sessionStorage.setItem('redirectPath', `/events`)
                }
                store.commit('setTriggerLogin', {loginStatus: true})
            },
            calculateTimeToStartEvent (evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
                let self = this
                let eventDate = new Date(evtDate)
//                let eventEndDate = new Date(endDate)
                let currentDate = this.returnEasternTime()
                let switchTime = parseInt(defaultSwitchTime)
                if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                    switchTime = parseInt(eventSwtichTime)
                }
                // console.log('time left', this.getMinutesBetweenDates(currentDate, eventDate))
                if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                    if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime) {
                    } else {
                        let timeToStart = this.getMinutesBetweenDates(currentDate, eventDate) - switchTime
                        if (timeToStart > 0 && timeToStart <= 90) {
                            let timeToTrigger = parseInt(timeToStart * 60 * 1000)
                            setTimeout(() => {
                                self.toggleSpinner = true
                                self.showRulesComp = false
                                setTimeout(() => {
                                    self.showRulesComp = true
                                    self.toggleSpinner = false
                                }, 1500)
                            }, timeToTrigger + 60)
                        }
                    }
                }
            }
        },
        mounted: function () {
            setTimeout(function () {
                window.addeventatc.refresh()
            }, 1500)
            this.$store.dispatch('GETDYNAMICCONTENTS', 19).then(() => {
                if (this.getAllSiteContents) {
                    // Load meta tags
                    this.metaTag_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_DESCRIPTION')
                    this.metaTag_keywords = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_KEYWORDS')
                    this.metaTag_fb_sitename = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME')
                    this.toneLiveHeading = this.setDynamicSection(this.getAllSiteContents, 'COMING_UP_TONE_HEADING')
                    this.toneTalkHeading = this.setDynamicSection(this.getAllSiteContents, 'TONE_TALKS_HEADING')
                    this.toneTalkDesc = this.setDynamicSection(this.getAllSiteContents, 'TONE_TALK_DESC')
                    // SEO Tags
                    this.metaTag_pageTitle = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_PAGE_TITLE')
                    this.metaTag_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_DESCRIPTION')
                    this.metaTag_keywords = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_KEYWORDS')
                    // OpenGraph Tags
                    this.metaTag_fb_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE')
                    this.metaTag_fb_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE')
                    this.metaTag_fb_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION')
                    this.metaTag_fb_sitename = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME')
                    // Twitter Tags
                    this.metaTag_tw_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_TITLE')
                    this.metaTag_tw_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE')
                    this.metaTag_tw_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION')
                }
            })
            let eventIdParam = this.$route.params.eventId
            let self = this
            if (!self.user) {
                self.$store.dispatch('GETEVENTLIST').then(() => {
                    // Set Event Listing
                    if (this.getEventList) {
                        // Set Live & Main Event & Talk Events
                        let liveEvents = this.getEventList.filter(x => {
                            return x.type === '1'
                        })
                        let talkEvents = this.getEventList.filter(x => {
                            return x.type === '2'
                        })
                        if (liveEvents && liveEvents.length > 0) {
                            liveEvents = liveEvents.slice(0, 3)
                            if (eventIdParam) { // EventId is provided
                                let mainEvent = liveEvents.filter(x => {
                                    return x.eventId.toString() === eventIdParam.toString()
                                })
                                if (mainEvent && mainEvent.length > 0) {
                                    self.mainLiveEvent = mainEvent[0]
                                    self.calculateTimeToStartEvent(self.mainLiveEvent.start_date, self.mainLiveEvent.end_date, self.mainLiveEvent.eventSwitchTime, self.getEventSwitchTime)
                                    self.allLiveEvents = liveEvents.filter(x => {
                                        return x.eventId !== self.mainLiveEvent.eventId
                                    })
                                } else { // Provided EventId is not found
                                    self.mainLiveEvent = liveEvents[0]
                                    self.allLiveEvents = liveEvents.slice(1, 3)
                                }
                            } else { // EventId not provided
                                self.mainLiveEvent = liveEvents[0]
                                self.calculateTimeToStartEvent(self.mainLiveEvent.start_date, self.mainLiveEvent.end_date, self.mainLiveEvent.eventSwitchTime, self.getEventSwitchTime)
                                self.allLiveEvents = liveEvents.slice(1, 3)
                            }
                        } else {
                            self.mainLiveEvent = null
                            self.allLiveEvents = null
                        }
                        // Set Talk Events
                        self.allTalkEvents = talkEvents
                        setTimeout(() => {
                            self.createCarousal()
                        }, 2000)
                        // Get Main Event Expert
                        console.log('main event object', self.mainLiveEvent)
                        // self.$store.dispatch('GETEXPERT', self.mainLiveEvent.expertId).then(() => {
                        //     if (self.getExpert) {
                        //         self.videoExpert = self.getExpert
                        //         // Get Video Object
                        //         self.$store.dispatch('GETCURRENTVIDEO', self.mainLiveEvent.jw_stream_title).then(() => {
                        //             if (self.getCurrentVideo) {
                        //                 let videoObj = self.getCurrentVideo[0]
                        //                 console.log('found video', videoObj)
                        //                 if (videoObj) {
                        //                     self.sharingImage = videoObj.image
                        //                     self.currentVideo = {
                        //                         video: videoObj.sources[videoObj.sources.length - 1].file,
                        //                         title: videoObj.title,
                        //                         img: videoObj.image,
                        //                         playerID: new Date(),
                        //                         tracks: videoObj.tracks,
                        //                         Description: videoObj.description,
                        //                         mediaId: videoObj.mediaid
                        //                     }
                        //                     console.log('video current status', self.currentVideo)
                        //                     self.sharingTitle = `TONE Live: ${self.mainLiveEvent.title} with ${self.videoExpert[0].name}`
                        //                     self.sharingImage = self.currentVideo.img
                        //                     self.sharingDescription = self.mainLiveEvent.longDescription
                        //                     self.$store.dispatch('CACHEPAGE', self.videoURL)
                        //                 }
                        //             }
                        //         })
                        //     }
                        // })
                    }
                })
            } else {
                self.$router.push('/events')
            }
        },
        computed: {
            ...mapGetters([
                'isUserLoggedIn', 'getEventList', 'user', 'getWorkVideo', 'getLifeVideos', 'getTalkEvents', 'getLiveEvents', 'getMoneyVideo', 'getMindbodyVideo', 'getCommunityVideo', 'isScrolled', 'getCurrentVideo', 'getAuthUserVideos', 'getCurrentStatus', 'getAuthRecommendedVideos', 'getExpert',
                'getCurrentVideoTranscript', 'getCurrentVideoDurationWatched', 'getVideEndMessage', 'getVideEndGif', 'getAllUnauthVideos', 'getAuthWorkVideos', 'getAuthLifeVideos', 'getAuthMindbodyVideos', 'getAuthMoneyVideos', 'getTalkEvents', 'getCorporateGiftingCode', 'getCorporateClient', 'getCorporateClientId', 'getEventSwitchTime', 'getAllSiteContents', 'getCorpFooterColor', 'getCorpHeadingColor', 'getCorpHeaderColor', 'getCorpButtonColor', 'getCorporateGiftInfo']
            )
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @media(max-width:768px){
        .row.morevediosrow {
            margin: 0;
        }
    }
    a {
        cursor: pointer !important;
    }
    .video-player-wrapper .watch-again .current-video-img img {
        object-fit: cover;
    }
    .video-player .right-video-icons .enjoy-hover-box {
        width: 20%;
        height: 100%;
        background: #f0617d;
        position: absolute;
        top: 0;
        right: 0;
        padding: 15% 0px 0;
        text-align: left;
    }
    .video-player .right-video-icons .enjoy-hover-box button.btn {
        margin: 0 0 10px;
        border-color: white;
        border-radius: 3px;
        padding: 12px 0 13px;
        display: block;
        width: 80%;
        margin: 0px auto 10px;
        color: #fff;
    }
    .video-player-wrapper .tooltipBox {
        width: 100%;
        text-align: center;
        padding-bottom: 10px;
        height: 35px;
        margin-top: 24px;
    }
    .row.morevediosrow img {
        max-width: 100%;
    }

    .clearfix {
        clear: both;
    }

    .gap {
        height: 30px;
    }
    h3.pinkheading {
        color: #f0617d;
        font-size: 28px;
        letter-spacing: 2px;
        margin: 10px 0 20px;
    }

    ul.pinkheading li  a {}

    ul.pinkheading li {
        margin: 5px 0 5px;
    }

    ul.pinkheading {
        margin: 0;
        padding: 0;
        font-size: 19px;
        font-weight: 900;
        list-style: none;
    }
    .row.morevediosrow > div:after {
        content: "\F04B";
        font-family: fontawesome;
        position: absolute;
        top: calc(50% - 25px);
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        color: rgba(255, 255, 255, 0.75);
        font-size: 57px;
        height: 90px;
        width: 90px;
        line-height: 84px;
        border: 5px solid;
        border-radius: 50%;
        text-align: center;
        padding-left: 12px;
        cursor: pointer;
        pointer-events: none;
    }
    @media (min-width:768px) {
        .video-player .right-video-icons .enjoy-hover-box {
            padding: 117px 0px 0;
        }
        .video-player .right-video-icons .enjoy-hover-box .rating {
            overflow: hidden;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
        }
        .video-player .right-video-icons .enjoy-hover-box .rating p {
            color: white;
            display: block;
            font-size: 16px;
            letter-spacing: 0.5px;
            margin-top: 23px;
            margin-bottom: 20px;
            padding: 0 10%;
            text-align: center;
        }
    }
    .video-player .right-video-icons .rate-hover-box span {
        margin-bottom: 20px;
    }
    .video-player .right-video-icons .rate-hover-box button:hover {
        background: #ac2925;
    }
    .video-player .btn-danger:focus {
        background: inherit;
        border-color: inherit;
        outline: none;
    }
    .video-player .right-video-icons div button.btn-danger:hover{
        background:rgba(0,0,0,0.1);
    }
    .video-player .right-video-icons div button.btn-danger.active:hover{
        background:#ac2925;
    }
    .video-player .right-video-icons div button.btn-danger.active:focus{
    color: #fff;
    background-color: #ac2925;
    border-color: #fff;
    }
    .profile-content img {
        object-fit: cover;
        object-position: center center;
    }
    .video-player .left-video-icons {
        background: white;
        color: white;
        width: 15%;
        float: left;
        height: 100%;
    }
    h3.errormessage {
        color: #f0617d;
        letter-spacing: 3px;
        margin: 70px 20px;
    }
    @media(max-width:767px){
        .row.morevediosrow img {
            margin-bottom: 10px;
        }
        .sliderTalkBox {
            padding: 0 15px;
        }
    }
    .row.morevediosrow p.text-wrap-title.cursor {
        font-size: 18px;
        text-align: left;
        color: #000;
    }
    .slick-slide {
        text-align: left;
    }

    .slick-slide  p {
        height: 152px;
        overflow-y: auto;
        margin: 0 0 20px;
    }
    .hello-page-wrapper.video-player-wrapper {
        padding-bottom:50px;
    }
   
::-webkit-scrollbar {
  width: 8px;
}
 
::-webkit-scrollbar-track {  
  border-radius: 10px;
  box-shadow: inset 0 0 5px grey; 
}
  
::-webkit-scrollbar-thumb {
  background: rgb(240, 97, 125); 
  border-radius: 10px;
}
 
::-webkit-scrollbar-thumb:hover {
  background: #b30000; 
}
    @media(min-width:768px){
        .slick-slide h2 {
            min-height: 66px;
        }
    }
    .slick-slide a:hover h2 {
        color: #f27991 !important;
        text-decoration: none;
    }

    .slick-slide a:hover {
        color: #f27991;
        text-decoration: none;
    }
    .row.morevediosrow a:hover, .row.morevediosrow a:hover p {
        color: #f1617d !important;
        text-decoration: none;
    }
    .container-icons > div > span {
        display: inline-block;
        background: #f0617d;
        height: 50px;
        width: 50px;
        color: #fff;
        text-align: center;
        line-height: 60px;
        border-radius: 50%;
    }
    @media (min-width:320px) and (max-width:575px){
        .container-icons.vpage {
            float: left;
            width: 100%;
            text-align: center;
        }

        p.video-description+div {
            width: 100%;
            text-align: center;
            margin: 0 0 20px;
        }
    }
    @media(max-width:767px){
        .row.morevediosrow > div:after{
            top: 26vw;
            width: 60px;
            height: 60px;
            font-size: 30px;
            line-height: 50px;
            padding-left: 5px;
        }
    }
</style>
<style>
    @media(min-width:320px) and (max-width:767px){
        .video-player.autoheight {
            height: auto;
        }

        .autoheight.video-player .jwplayer.jw-flag-aspect-mode {
            height: auto !important;
        }
    }

    .autoheight div.jw-error.jw-reset {
        height: 25vw !important;
    }
    .video-player .left-video-icons{
        height: 25vw !important;
    }
    .autoheight{
        height: auto !important;
        padding-bottom:20px;
    }
</style>



// WEBPACK FOOTER //
// NewEvents.vue?64c68b0e